import { render } from "./FunctionalFooter.vue?vue&type=template&id=af3de594&scoped=true"
import script from "./FunctionalFooter.vue?vue&type=script&lang=js"
export * from "./FunctionalFooter.vue?vue&type=script&lang=js"

import "./FunctionalFooter.vue?vue&type=style&index=0&id=af3de594&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3de594"]])

export default __exports__